import { LocalStorageKey } from '@src/core/storage/local';
import { LocalStorageService } from '@src/core/storage/local/local-storage.service';

let recentVisitedTimerID;
export const updateRecentlyVisited = (identifier: string) => {
  const localStorage = new LocalStorageService(document);

  clearTimeout(recentVisitedTimerID);
  recentVisitedTimerID = setTimeout(() => {
    localStorage.removeItem(LocalStorageKey.RecentVisitedPages);
  }, 1000 * 60 * 10);

  const recentVisited = localStorage.getItem<string[]>(LocalStorageKey.RecentVisitedPages);
  if (!recentVisited) {
    localStorage.setItem(LocalStorageKey.RecentVisitedPages, [identifier]);
    return;
  }
  const indexOfAlreadyVisitedItem = recentVisited.indexOf(identifier);
  if (indexOfAlreadyVisitedItem !== -1) {
    recentVisited.splice(indexOfAlreadyVisitedItem, 1);
  }
  recentVisited.push(identifier);
  localStorage.setItem(LocalStorageKey.RecentVisitedPages, recentVisited);
};
